import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: 'AIzaSyAdhfMS2BSsNwsit2q_rCAGggjVItOceP0',
  authDomain: 'leo-sso.firebaseapp.com',
};

export const firebaseApp = initializeApp(firebaseConfig);
